<template>
  <div>
    <landing-create :content="content"></landing-create>
    <list-component
      :service="service"
      :tableMetaData="tableMetaData"
    ></list-component>
  </div>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ListComponent from '../../../components/ListComponent.vue';
import services from '../../../services';

const { biobankRegistry } = services;
const { boxService } = biobankRegistry;

export default {
  name: 'boxList',
  components: {
    ListComponent,
    LandingCreate,
  },
  data() {
    const component = this;
    return {
      service: boxService,
      tableMetaData: {
        tableFilters: {
          selections: [],
          dates: [
            {
              text: 'Date created',
              column: 'dateCreated',
            },
            {
              text: 'Date updated',
              column: 'dateUpdated',
            },
          ],
        },
        tableHeaders: [
          {
            text: 'Box Number',
            value: 'name',
          },
          {
            text: 'Created by',
            value: '_metadata.created.user.fullName',
          },
          {
            text: 'Date created',
            value: '_metadata.created.date',
          },
          {
            text: 'Actions',
            value: 'actions',
          },
        ],
        URLName: 'box',
        actionDisplay: {
          delete: {
            visible: true,
            icon: () => 'mdi-delete-empty',
          },
        },
        onClickArchive(item) {
          component.onArchive(item);
        },
      },
      content: {
        pageTitle: 'Box',
        commands: [
          {
            link: 'box.create',
            icon: 'mdi-plus-box',
            buttonName: 'Create',
          },
        ],
      },
    };
  },
  methods: {
    async onArchive(item) {
      this.isLoading = true;
      try {
        await boxService.archive({ box: item });
        this.$snackbar.show({
          text: 'Successfully deleted box!',
          closeColor: 'white',
          color: 'green',
        });
      } catch (e) {
        console.log('catch', e);
        const { message } = e.response.data;
        this.$snackbar.show({ color: 'red', text: message, closeColor: 'white' });
      }
      this.isLoading = false;
    },
  },
};
</script>
